export const FLAG_GETTING_DELIVERY_PRICES = 'FLAG_GETTING_DELIVERY_PRICES';
export const GET_DELIVERY_PRICES = 'GET_DELIVERY_PRICES';
export const CLEAR_DELIVERY_PRICES = 'CLEAR_DELIVERY_PRICES';
export const FLAG_DELIVERY_PRICE_ACTIVITY = 'FLAG_DELIVERY_PRICE_ACTIVITY';
export const GET_DELIVERY_PRICE = 'GET_DELIVERY_PRICE';
export const CLEAR_DELIVERY_PRICE = 'CLEAR_DELIVERY_PRICE';
